export default "__VITE_ASSET__da877ea9__"